import { ToastCustom } from "@components";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "sonner";
import { importExpensesPreview } from "../services";
import type { ExpenseImportPreviewResponse } from "../types";

type FleeterValidationError = {
	type: string;
	title?: string;
	status?: number;
	detail?: string;
	errors?: string[];
	fieldsErrors?: Record<string, string[]>;
};

export function useImportExpensesPreview() {
	return useMutation<
		ExpenseImportPreviewResponse,
		AxiosError<{ error: FleeterValidationError }>,
		FormData
	>({
		mutationFn: (formData) => importExpensesPreview(formData),
		onError: (error) => {
			const errorData = error.response?.data?.error;

			if (errorData?.type === "FleeterValidationException") {
				const uniqueErrors = Array.from(
					new Set(errorData.errors ?? [errorData.detail].filter(Boolean))
				) as string[];

				if (uniqueErrors.length > 0) {
					toast(
						ToastCustom({
							description: uniqueErrors.join(" "),
							title: "Erro de validação",
							variant: "error",
						})
					);
					return;
				}
			}

			const fallbackMessage =
				errorData?.detail ??
				errorData?.errors?.[0] ??
				"Erro ao validar os dados da planilha.";

			toast(
				ToastCustom({
					description: fallbackMessage,
					title: "Erro na importação",
					variant: "error",
				})
			);
		},
	});
}
